module.exports = __webpack_public_path__ + "img/hidrometro.992af27e.png";